import { useEffect } from 'react';

interface SchemaOrgProps {
  id: string;
  schema: object;
}

export default function SchemaOrg({ id, schema }: SchemaOrgProps) {
  useEffect(() => {
    const existingScript = document.getElementById(`schema-${id}`);
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `schema-${id}`;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(`schema-${id}`);
      if (s) s.remove();
    };
  }, [id]);

  return null;
}
